import { styled } from '@mui/material/styles'
import MuiToolbar from '@mui/material/Toolbar'

export default styled(MuiToolbar)(({ theme }) => ({
  height: 80,
  [theme.breakpoints.up('sm')]: {
    height: 90,
  },
}))
